import { IS_MOBILE_DEVICE, IS_NOT_MOBILE_DEVICE, getAction } from './type.actions';

export const isMobileDeviceAction = () => getAction(IS_MOBILE_DEVICE);
export const isNotMobileDeviceAction = () => getAction(IS_NOT_MOBILE_DEVICE);
